import React from 'react';
import 'normalize.css';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import Nav from './Nav';
import Content from './Content';
import Footer from './Footer';
import GlobalStyles from '../styles/GlobalStyles';
import Typography from '../styles/Typography';
import { ThemeProvider as ThemeContextProvider, ThemeContext } from '../context/ThemeContext';

const ContentStyles = styled.div`
  max-width: 1200px;
  margin: auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

// Separate component to consume context safely
const LayoutContent = ({ children }) => {
  const { theme } = React.useContext(ThemeContext);
  const data = useStaticQuery(graphql`
    query {
      sanityHome {
        lightModeBg {
          asset {
            url
          }
        }
        darkModeBg {
          asset {
            url
          }
        }
      }
    }
  `);

  const lightBgUrl = data?.sanityHome?.lightModeBg?.asset?.url;
  const darkBgUrl = data?.sanityHome?.darkModeBg?.asset?.url;
  
  return (
      <>
        <Typography />
        <GlobalStyles theme={theme} lightBgUrl={lightBgUrl} darkBgUrl={darkBgUrl} />
  
        <ContentStyles>
          <div style={{ flex: 1 }}>
            <Nav />
            <Content>{children}</Content>
          </div>
          <Footer />
        </ContentStyles>
      </>
  );
}

export default function Layout({ children }) {
  return (
    <ThemeContextProvider>
       <LayoutContent>{children}</LayoutContent>
    </ThemeContextProvider>
  );
}
